/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdminDetailsResponse } from './';
import {
    AdminDetailsResponseFromJSON,
    AdminDetailsResponseFromJSONTyped,
    AdminDetailsResponseToJSON,
} from './';
import type { AvailabilityResponse } from './';
import {
    AvailabilityResponseFromJSON,
    AvailabilityResponseFromJSONTyped,
    AvailabilityResponseToJSON,
} from './';
import type { ConsultingOfferResponse } from './';
import {
    ConsultingOfferResponseFromJSON,
    ConsultingOfferResponseFromJSONTyped,
    ConsultingOfferResponseToJSON,
} from './';
import type { LocationResponse } from './';
import {
    LocationResponseFromJSON,
    LocationResponseFromJSONTyped,
    LocationResponseToJSON,
} from './';
import type { PhotoResponse } from './';
import {
    PhotoResponseFromJSON,
    PhotoResponseFromJSONTyped,
    PhotoResponseToJSON,
} from './';
import type { PortfolioItemResponse } from './';
import {
    PortfolioItemResponseFromJSON,
    PortfolioItemResponseFromJSONTyped,
    PortfolioItemResponseToJSON,
} from './';
import type { PriceResponse } from './';
import {
    PriceResponseFromJSON,
    PriceResponseFromJSONTyped,
    PriceResponseToJSON,
} from './';
import type { RefinementCriterionResponse } from './';
import {
    RefinementCriterionResponseFromJSON,
    RefinementCriterionResponseFromJSONTyped,
    RefinementCriterionResponseToJSON,
} from './';
import type { SkillResponse } from './';
import {
    SkillResponseFromJSON,
    SkillResponseFromJSONTyped,
    SkillResponseToJSON,
} from './';
import type { StatisticsResponse } from './';
import {
    StatisticsResponseFromJSON,
    StatisticsResponseFromJSONTyped,
    StatisticsResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileResponse
 */
export interface ProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    lastNameNormalized: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    headline: string;
    /**
     * 
     * @type {PhotoResponse}
     * @memberof ProfileResponse
     */
    photo: PhotoResponse;
    /**
     * 
     * @type {LocationResponse}
     * @memberof ProfileResponse
     */
    location: LocationResponse;
    /**
     * 
     * @type {PriceResponse}
     * @memberof ProfileResponse
     */
    price: PriceResponse;
    /**
     * 
     * @type {AvailabilityResponse}
     * @memberof ProfileResponse
     */
    availability: AvailabilityResponse;
    /**
     * 
     * @type {StatisticsResponse}
     * @memberof ProfileResponse
     */
    stats: StatisticsResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileResponse
     */
    badges: Array<ProfileResponseBadgesEnum>;
    /**
     * 
     * @type {Array<SkillResponse>}
     * @memberof ProfileResponse
     */
    skills: Array<SkillResponse>;
    /**
     * 
     * @type {Array<PortfolioItemResponse>}
     * @memberof ProfileResponse
     */
    portfolio: Array<PortfolioItemResponse>;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    url: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileResponse
     */
    strongMatch?: boolean;
    /**
     * 
     * @type {Array<RefinementCriterionResponse>}
     * @memberof ProfileResponse
     */
    refinementCriteria?: Array<RefinementCriterionResponse>;
    /**
     * 
     * @type {AdminDetailsResponse}
     * @memberof ProfileResponse
     */
    adminDetails?: AdminDetailsResponse;
    /**
     * 
     * @type {ConsultingOfferResponse}
     * @memberof ProfileResponse
     */
    consultingOffer?: ConsultingOfferResponse;
}


/**
 * @export
 */
export const ProfileResponseBadgesEnum = {
    NewMalter: 'NEW_MALTER',
    SuperMalter1: 'SUPER_MALTER_1',
    SuperMalter2: 'SUPER_MALTER_2',
    SuperMalter3: 'SUPER_MALTER_3'
} as const;
export type ProfileResponseBadgesEnum = typeof ProfileResponseBadgesEnum[keyof typeof ProfileResponseBadgesEnum];


/**
 * Check if a given object implements the ProfileResponse interface.
 */
export function instanceOfProfileResponse(value: object): value is ProfileResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastNameNormalized' in value) || value['lastNameNormalized'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    if (!('photo' in value) || value['photo'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('stats' in value) || value['stats'] === undefined) return false;
    if (!('badges' in value) || value['badges'] === undefined) return false;
    if (!('skills' in value) || value['skills'] === undefined) return false;
    if (!('portfolio' in value) || value['portfolio'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ProfileResponseFromJSON(json: any): ProfileResponse {
    return ProfileResponseFromJSONTyped(json, false);
}

export function ProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastNameNormalized': json['lastNameNormalized'],
        'headline': json['headline'],
        'photo': PhotoResponseFromJSON(json['photo']),
        'location': LocationResponseFromJSON(json['location']),
        'price': PriceResponseFromJSON(json['price']),
        'availability': AvailabilityResponseFromJSON(json['availability']),
        'stats': StatisticsResponseFromJSON(json['stats']),
        'badges': json['badges'],
        'skills': ((json['skills'] as Array<any>).map(SkillResponseFromJSON)),
        'portfolio': ((json['portfolio'] as Array<any>).map(PortfolioItemResponseFromJSON)),
        'url': json['url'],
        'strongMatch': json['strongMatch'] == null ? undefined : json['strongMatch'],
        'refinementCriteria': json['refinementCriteria'] == null ? undefined : ((json['refinementCriteria'] as Array<any>).map(RefinementCriterionResponseFromJSON)),
        'adminDetails': json['adminDetails'] == null ? undefined : AdminDetailsResponseFromJSON(json['adminDetails']),
        'consultingOffer': json['consultingOffer'] == null ? undefined : ConsultingOfferResponseFromJSON(json['consultingOffer']),
    };
}

export function ProfileResponseToJSON(value?: ProfileResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastNameNormalized': value['lastNameNormalized'],
        'headline': value['headline'],
        'photo': PhotoResponseToJSON(value['photo']),
        'location': LocationResponseToJSON(value['location']),
        'price': PriceResponseToJSON(value['price']),
        'availability': AvailabilityResponseToJSON(value['availability']),
        'stats': StatisticsResponseToJSON(value['stats']),
        'badges': value['badges'],
        'skills': ((value['skills'] as Array<any>).map((v) => SkillResponseToJSON(v))),
        'portfolio': ((value['portfolio'] as Array<any>).map((v) => PortfolioItemResponseToJSON(v))),
        'url': value['url'],
        'strongMatch': value['strongMatch'],
        'refinementCriteria': value['refinementCriteria'] == null ? undefined : ((value['refinementCriteria'] as Array<any>).map((v) => RefinementCriterionResponseToJSON(v))),
        'adminDetails': AdminDetailsResponseToJSON(value['adminDetails']),
        'consultingOffer': ConsultingOfferResponseToJSON(value['consultingOffer']),
    };
}

